import React from 'react';
import { Box, TextField } from '@mui/material';
import { ClientAddressValue } from 'shared/types/appTypes';

interface AddressFieldProps {
  value: ClientAddressValue;
  onChange: (value: ClientAddressValue) => void;
  autoFocus?: boolean;
  disabled?: boolean;
}

const DEFAULT_ADDRESS: ClientAddressValue = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  postalCode: '',
  country: '',
};

const AddressField: React.FC<AddressFieldProps> = ({ value, onChange, autoFocus, disabled }) => {
  const address = value || DEFAULT_ADDRESS;

  const handleChange = (key: keyof ClientAddressValue, next: string) => {
    onChange({
      ...address,
      [key]: next,
    });
  };

  return (
    <Box
      sx={{
        mt: 2,
        width: '100%',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
        gap: 1.5,
      }}
    >
      <TextField
        label="Address Line 1"
        value={address.addressLine1}
        onChange={(e) => handleChange('addressLine1', e.target.value)}
        fullWidth
        size="small"
        autoFocus={autoFocus}
        disabled={disabled}
        sx={{ gridColumn: { xs: 'span 1', sm: 'span 2' } }}
      />
      <TextField
        label="Address Line 2"
        value={address.addressLine2}
        onChange={(e) => handleChange('addressLine2', e.target.value)}
        fullWidth
        size="small"
        disabled={disabled}
        sx={{ gridColumn: { xs: 'span 1', sm: 'span 2' } }}
      />
      <TextField
        label="City"
        value={address.city}
        onChange={(e) => handleChange('city', e.target.value)}
        fullWidth
        size="small"
        disabled={disabled}
      />
      <TextField
        label="State / Province"
        value={address.state}
        onChange={(e) => handleChange('state', e.target.value)}
        fullWidth
        size="small"
        disabled={disabled}
      />
      <TextField
        label="Postal Code"
        value={address.postalCode}
        onChange={(e) => handleChange('postalCode', e.target.value)}
        fullWidth
        size="small"
        disabled={disabled}
      />
      <TextField
        label="Country"
        value={address.country}
        onChange={(e) => handleChange('country', e.target.value)}
        fullWidth
        size="small"
        disabled={disabled}
      />
    </Box>
  );
};

export default AddressField;
